import { InvoiceTemplateContentBody } from "@common/schemas/domains/invoice/invoice-template.schema";
import { NativeInvoiceDraftBody } from "@common/schemas/domains/invoice/native-invoice.schema";

export function toInvoiceTemplateContentBody(
    draft: NativeInvoiceDraftBody,
): InvoiceTemplateContentBody {
    const {
        status,
        revisedFromInvoiceId,
        billableExpenseTransactionIds,
        sourceTemplateId,
        ...content
    } = draft;
    void status;
    void revisedFromInvoiceId;
    void billableExpenseTransactionIds;
    void sourceTemplateId;
    return content;
}
